import leases from './leases'
import properties from './properties'

export default { leases, properties }
